<template>
  <div class="bet-slip bet-slip-parlay">
    <div class="bet-slip-content" :class="{ bgColorWhite: isScanningCodeForMobile }">
      <div>
        <bet-alert-message
          v-if="freeWagersViewing && betModel.Selections.length < 2"
          error
          withoutIcon
          :description="$t('BetSlip.FreeWager.MinParlayError')"
        />

        <bet-alert-message
          v-if="!betModel.IsSuccess"
          error
          withoutIcon
          :description="parseBetErrorMessage(betOptionsResponse)"
        />

        <!-- checkbox geliştirmesi yapıldıktan sonra v-else kaldır -->
        <div v-else class="bet-scroll-wrapper">
          <div v-for="(bet, index) in betModel.Selections" :key="bet.OutComeId">
            <bet-alert-message
              v-if="!bet.error.IsSuccess"
              :description="parseBetErrorMessage(bet.error)"
              :canClose="true"
              @onRemove="removeBetFromSlipByIndex(bet.OutComeId)"
            />
            <bet-slip-selection
              v-else
              class="bet-slip-item-wrapper"
              :selection="bet"
              :isChecked="isChecked(bet.OutComeId)"
              :show-checkbox="showCheckbox"
              :showBuyPoints="true"
              @onBuyPointChange="onRiskChange(bet)"
              @onRemove="removeBetFromSelections(bet.OutComeId)"
              @accept="onRiskChange(bet)"
              @lineChecked="lineChecked(betModel, bet, $event)"
            ></bet-slip-selection>
          </div>
        </div>
      </div>

      <div class="sticky-wrapper">
        <div v-if="(!freeWagersViewing && betModel.Selections.length < 2) || !(betModel && !betModel.IsSuccess)">
          <div class="bet-slip-item-wrapper d-flex" :class="{ 'append-left': showCheckbox }" style="border: 0">
            <bet-slip-risk-input
              :amount.sync="betModel.input_risk_amount"
              @change="onRiskChange(betModel)"
              :min="getRiskInputMinAmount(betModel)"
              :max="getBetMaxLimit(betModel)"
              type="RISK"
              :limit-control="hasError('RISK', betModel)"
              :is-custom-limit-control="true"
            ></bet-slip-risk-input>
            <bet-slip-risk-input
              :amount.sync="betModel.input_win_amount"
              :riskedAmount="betModel.input_risk_amount"
              @change="onWinChange(betModel)"
              :min="betModel.open_spots != 0 ? null : getRiskInputMinAmount(betModel)"
              :max="getMaxPayoutLimit(betModel)"
              type="WIN"
              :limit-control="hasError('WIN', betModel)"
              :is-custom-limit-control="true"
            ></bet-slip-risk-input>
          </div>

          <div
            class="betslip-input-error p-1 bg-white"
            v-if="minErrorCondition(betModel) && !minBetConditionByBet(betModel)"
            v-html="betSlipMinError(getBetMinLimit(betModel), betModel)"
          ></div>
          <div
            class="betslip-input-error p-0"
            v-if="maxErrorCondition(betModel) && !minBetConditionByBet(betModel)"
            v-html="betSlipMaxError(getBetMaxLimit(betModel), betModel)"
          ></div>

          <div
            class="betslip-input-error error-3 p-1"
            v-if="minBetConditionByBet(betModel)"
            v-html="minBetConditionError()"
          ></div>

          <div
            class="bet-slip-item-wrapper append-left mb-0"
            style="border: 0"
            v-if="snq(() => betModel.options.open_spot_options.length)"
          >
            <div class="row align-items-center">
              <div class="col-6">
                <span class="bet-slip-bet-type-title m-0">{{ $t('BetSlip.ChooseOption.Parlay') }}</span>
              </div>
              <div class="col-6">
                <select
                  class="form-control bet-slip-form-control w-100 mb-0"
                  v-model="bet.open_spots"
                  @change="onOpenSpotsChange(betModel)"
                >
                  <option value="0">{{ $t('BetSlip.OpenSpots.NotSelected') }}</option>
                  <option
                    v-for="opt in betModel.options && betModel.options.open_spot_options"
                    :key="opt.open_spots_bought"
                    :value="opt.open_spots_bought"
                  >
                    {{ opt.open_spots_bought }}
                  </option>
                </select>
              </div>
              <div class="col-12">
                <div class="betslip-input-error p-0" v-if="betModel.Selections.length <= 1 && betModel.open_spots == 0">
                  {{ $t('BetSlip.OpenSpots.Error') }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="mb-3" v-if="betOptionsResponse.Selections.length">
          <span class="total-parlay">Parlay ({{ betOptionsResponse.Selections.length }}): {{ parlayOddCalculation() }}</span>
        </div>

        <total-amounts
          class="mt-1"
          :totalBets="getTotalBetsCount()"
          :totalRiskAmount="getTotalRiskAmount()"
          :totalRiskAmountWithoutTax="getTotalRiskAmountWithoutTax()"
          :totalWinAmount="activeFreeBet ? getTotalFreeBetWinAmount() : getTotalWinAmount()"
          :showFreePlayIfEligible="true"
          :betOptionsResponse="betModel"
          :disable-place-bet-button="disablePlaceBetButton"
          :wagerType="getWagerType()"
        ></total-amounts>
      </div>
    </div>
  </div>
</template>

<script>
import BetSlipMixin from './bet-slip-mixin';
import { mapActions, mapGetters, mapState, mapMutations } from 'vuex';
import { isChecked, setChecked } from '@/views/sports/components/bet-slip/check-bets';
import snq from 'snq';
import {
  fractionFromUS,
  parlaycalculationodd,
  oddToMoneyline,
  decimalFromUS,
  roundAmount,
  americanToDecimal,
  parlayNewCalculationOdds
} from './bet-slip-utils';

export default {
  mixins: [BetSlipMixin],
  mounted() {
    if (this.getParlays()[0]) {
      this.onRiskChange(this.getParlays()[0]);
    }
  },
  data() {
    return {
      betModel: null,
      betObject: null,
    };
  },
  computed: {
    ...mapGetters('player', ['currency', 'currencySymbol']),
    ...mapState({
      betOptionsResponse: (state) => state.betSlip.betOptionsResponse,
      activeFreeBet: (state) => state.betSlip.activeFreeBet,
      selectedOddType: (state) => state.settings.selectedOddType,
      isScanningCodeForMobile: (state) => state.settings.isScanningCodeForMobile,
    }),
    disablePlaceBetButton() {
      return this.betModel.Selections.some((bet) => {
        return (
          this.minErrorCondition(bet) ||
          this.maxErrorCondition(bet) ||
          this.minBetConditionByBet(bet) ||
          !bet.error.IsSuccess
        );
      });
    },
  },
  watch: {
    selectedOddType: function (value) {
      this.parlayTotalCalc();
    },
  },

  methods: {
    ...mapMutations({
      setBetOptionsResponse: 'betSlip/setBetOptionsResponse',
    }),
    isChecked,
    snq,
    ...mapActions({
      getNewBetOptions: 'betSlip/getNewBetOptions',
    }),

    getWagerType() {
      return 'parlay';
    },

    onRiskChange(bet) {
      const justWin = bet.input_win_amount;
      bet.input_win_amount = this.activeFreeBet ? this.getTotalFreeBetWinAmount() : this.getTotalWinAmount();
      bet.input_win_amount = Number(bet.input_win_amount) + Number(bet.input_risk_amount);

      if (justWin >= bet.limits.max_payout_amount) {
        bet.input_win_amount = bet.limits.max_payout_amount;
      }
      bet.Selections.forEach((f, i) => {
        if (i === 0) {
          f.input_risk_amount = bet.input_risk_amount;
          f.input_win_amount = bet.input_win_amount;
        } else {
          f.input_risk_amount = 0;
          f.input_win_amount = 0;
        }
      });

      this.notifyBetSlip(bet);
    },
    onWinChange(bet) {
      bet.input_risk_amount = this.roundAmount(bet.input_win_amount / this.multiplyOdds());
      this.notifyBetSlip(bet);
    },
    onOpenSpotsChange(bet) {
      this.notifyBetSlip(bet);
    },
    notifyBetSlip(bet) {
      this.createOrUpdateBet(
        this.createBet(bet.WagerType, '', bet.input_risk_amount, bet.input_win_amount, 0, bet.open_spots, null),
      );
    },
    getTotalRiskAmount() {
      let total = 0;
      this.betModel.Selections.forEach((bet) => {
        if (bet.input_risk_amount !== '') {
          const input_risk_amount = parseFloat(bet.input_risk_amount);
          total += parseFloat(
            this.$taxHelper.applyTaxToRiskInputHidden({
              input_risk_amount,
            }),
          );
        }
      });

      if (parseFloat(total) < 0) {
        return 0;
      }

      if (this.activeFreeBet) return 0;

      return this.roundAmount(total);
    },
    getTotalRiskAmountWithoutTax() {
      let total = 0;
      this.betModel.Selections.forEach((bet) => {
        if (bet.input_risk_amount !== '') {
          const input_risk_amount = parseFloat(bet.input_risk_amount);
          total += input_risk_amount;
        }
      });
      if (this.activeFreeBet) return 0;
      return this.roundAmount(total);
    },getMaxPayoutUsed(){
      if (this.betModel.limits.max_payout_amount > 0 &&  this.betModel.limits.max_payout_amount < this.betModel.limits.parlay_table_row.MaxPayout / 100) {
        return this.betModel.limits.max_payout_amount;
      } else if(this.betModel.limits.parlay_table_row.MaxPayout>0) {
        return this.betModel.limits.parlay_table_row.MaxPayout / 100;
      }
      return 0;
    },useParlayTable(){
      let useTable=true;
      this.betModel.Selections.forEach((bet) => {
        var decimalOdd = this.roundAmount(this.americanToDecimal(bet.Odd));
        if (decimalOdd !== '1.91') {
          useTable= false;
        }
      });
        return useTable;
    },
    getTotalParlayWinAmount() {
      let total = 0;
      let riskAmount = 0;
	    let maxPayout = 0;
      riskAmount = parseFloat(
        this.$taxHelper.applyTaxToRiskInputHidden({
          input_risk_amount: +this.betModel.input_risk_amount,
        }),
      );
      total = riskAmount * this.multiplyOdds();
      this.betModel.fixedParlayMultiply= this.useParlayTable();
      if (this.betModel.fixedParlayMultiply) {
        total = riskAmount * this.betModel.limits.parlay_table_row.Odds / 100;
        maxPayout = this.getMaxPayoutUsed();
        if(maxPayout<total && maxPayout>0){
            total=maxPayout;
        }
      } else {
        if (total >= this.betModel.limits.max_payout_amount) {
          total = this.betModel.limits.max_payout_amount;
        }
      }
      let final = this.roundAmount(total);
      if (parseFloat(final) < 0) {
        return 0;
      }
      return final;
    },
    getTotalWinAmount() {
      return this.getTotalParlayWinAmount();
    },
    getTotalFreeBetWinAmount() {
      let riskAmount = parseFloat(
        this.$taxHelper.applyTaxToRiskInputHidden({
          input_risk_amount: +this.betModel.input_risk_amount,
        }),
      );
      let total = this.getTotalParlayWinAmount() - riskAmount;
      return total;
    },
    multiplyOdds() {
      let oddsMultiplied = parseFloat(this.parlayTotalCalc());
      // this.betModel.Selections.forEach((bet) => {
      //   oddsMultiplied *= this.americanToDecimal(bet.Odd);
      // });
      return oddsMultiplied;
    },
    getTotalBetsCount() {
      return this.betModel.Selections.filter((bet) => parseFloat(bet.input_win_amount) > 0).length;
    },
    triggerRiskChangeForAllBets() {
      this.betModel.Selections.map((bet) => this.onRiskChange(bet));
    },
    parlayError(min) {
      let text = this.$i18n.t('betslip.amountError').toString();
      text = text.replace('{currency}', this.currency);
      text = text.replace('{min}', min);
      return text;
    },
    lineChecked(bet, selection) {
      setChecked(selection.selection_identifier);
      bet.input_win_amount = this.getTotalWinAmount();
      this.notifyBetSlip(bet);
      this.getNewBetOptions();
    },

    getOdd(odd) {
      if (this.selectedOddType == 'D') {
        return roundAmount(americanToDecimal(odd));
      } else if (this.selectedOddType == 'E') {
        return odd > 0 ? `+${odd}` : odd;
      } else {
        return fractionFromUS(odd);
      }
    },

    parlayOddCalculation(){
      let returnOdd = parlayNewCalculationOdds(
          this.betOptionsResponse.Selections,
          this.betOptionsResponse.limits.max_payout_amount
      );

      return this.getOdd(returnOdd);
    },

    parlayTotalCalc() {
      let returnOdd = parlaycalculationodd(
          this.betOptionsResponse.Selections,
          this.betOptionsResponse.limits.max_payout_amount,
          this.betOptionsResponse,
      );
      return  returnOdd/100;
    },

  },
  created() {
    this.betModel = this.getParlays();
    this.betModel.WagerType = 'parlay';
  },
};
</script>
